import coverImg from "assets/images/v135/cover.webp"
import titleImg from "assets/images/v135/title.webp"

export const v135Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
